import { useMutation } from 'query';
import { requestMagicLink } from '../../services';

type Variables = {
  email: string;
  referrer?: string;
};

export const useRequestMagicLinkQuery = () =>
  useMutation<undefined, Variables>({
    async mutationFn(data: Variables) {
      await requestMagicLink({
        /* eslint-disable @typescript-eslint/naming-convention -- Start: required by backend API */
        body: {
          email: data.email,
          redirect_url: data.referrer ? window.origin + data.referrer : undefined,
        },
        /* eslint-enable @typescript-eslint/naming-convention -- End: required by backend API */
      });

      return undefined;
    },
  });
